import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { CONTACT_FORM } from '../../../campaigner-info/components/campaigner-info/placeholder';
import { IUser } from '../../../../shared/models';
import { EventsService, FundraiserService, UtilService, VariablesService } from '../../../../shared/services';

@Component({
  selector: 'app-ask-update',
  templateUrl: './ask-update.component.html',
  styleUrls: ['./ask-update.component.scss']
})
export class AskUpdateComponent implements OnInit, OnDestroy {

  @Input() isDonated;
  @Input() id;
  @Output() isNotDonated = new EventEmitter<any>();
  @Output() isAskedForUpdate = new EventEmitter<any>();
  label = 'Ask for update';
  askUpdateForm: FormGroup;
  name: FormControl;
  email: FormControl;
  gcaptcha: FormControl;
  info = CONTACT_FORM;
  userdata: IUser;
  userdataSubs: Subscription;
  isLoggedIn;
  isLoggedInSubs;
  isAsked = false;
  constructor(
    private utilService: UtilService,
    private fundraiserService: FundraiserService,
    private variablesService: VariablesService,
    public dialog: MatDialog,
    private events: EventsService
  ) { }

  ngOnInit() {
    this.initForm();
    this.userdataSubs = this.variablesService.userData.subscribe({ next: res => this.userdata = res });
    this.isLoggedInSubs = this.utilService.isLoggedIn.subscribe({ next: res => this.isLoggedIn = res });
    this.variablesService.showThankYoubanner.subscribe({
      next: (res) => {
        if (res) { this.isDonated = true; }
      }
    });
  }

  initForm() {
    this.askUpdateForm = new FormGroup({
      name: this.name = new FormControl('', [Validators.required, Validators.maxLength(50), Validators.minLength(3)]),
      email: this.email = new FormControl('', [
        Validators.required, Validators.pattern(this.variablesService.email_Pattern_Regex)
      ]),
      gcaptcha: this.gcaptcha = new FormControl('', [Validators.required]),
    });
  }
  openDialog(template): void {
    this.dialog.open(template, {
      width: '100vw',
      maxWidth: '500px',
      panelClass: 'round-dialog'
    });
    this.events.sendSystemEvent({
      eventName: 'update_asked',
      info_1: this.userdata?.id || '',
    }).subscribe(_=>_);
  }
  submit() {
    if (this.askUpdateForm.valid) {
      const payload = {
        'ask_username': this.name.value,
        'ask_userEmail': this.email.value,
        'action': 'send_ask_update',
      };
      payload['fmd_id'] = this.id ? this.id : this.variablesService.fundraiser.id;
      if (!this.utilService.isWLSite()) {
        payload['g-recaptcha-response'] = this.gcaptcha.value;
      }
      this.askForUpdate(payload);
    } else {
      this.utilService.checkValidForm(this.askUpdateForm);
    }
  }
  askForUpdateCheck(template?) {
    if (this.isDonated) {
      const payload = {
        'ask_username': this.userdata.full_name,
        'ask_userEmail': this.userdata.email,
        'action': 'send_ask_update',
      };
      payload['fmd_id'] = this.id ? this.id : this.variablesService.fundraiser.id;
      if (payload.ask_userEmail) {
        this.askForUpdate(payload);
      } else {
        this.openDialog(template);
      }
    } else if (!this.isDonated && this.isLoggedIn) {
      this.events.sendSystemEvent({
        eventName: 'update_asked',
        info_1: this.userdata?.id || '',
      }).subscribe(_=>_);
      this.isNotDonated.emit(true);
    } else {
      this.openDialog(template);
    }
  }
  askForUpdate(payload) {
    const id = this.id ? this.id : this.variablesService.fundraiser.id;
    this.isAsked = true;
    this.fundraiserService.askForUpdate(id, payload).subscribe((res: any) => {
      this.dialog.closeAll();
      this.label = 'Update Requested';
      this.isAskedForUpdate.emit(JSON.parse(res.data.status));
      this.utilService.openSnackBar('Your request for an update has been sent to the campaigner successfully!', 'success');
    }, (error) => {
      this.dialog.closeAll();
      this.isNotDonated.emit(error.error.error);
      this.isAsked = false;
    });
  }

  ngOnDestroy() {
    if (this.userdataSubs) { this.userdataSubs.unsubscribe(); }
    if (this.isLoggedInSubs) { this.isLoggedInSubs.unsubscribe(); }
  }

}
